<main class="auth-page min-vh-100 bg-light">
  <div class="container min-vh-100 d-flex align-items-center py-5">
    <div class="auth-panel row g-0 w-100 justify-content-center shadow-lg rounded-4 overflow-hidden bg-white">
      <section class="auth-brand-panel col-lg-6 text-white p-4 p-md-5 d-none d-lg-flex flex-column">
        <router-link to="/login" class="d-inline-flex bg-white rounded-3 p-3 shadow" aria-label="Department of Basic Education login">
          <span class="auth-logo d-block" aria-hidden="true"></span>
        </router-link>

        <div class="my-auto py-5">
          <p class="text-uppercase small text-white-50 fw-semibold mb-2">Account recovery</p>
          <h1 class="display-6 fw-bold mb-3">Your account is ready.</h1>
          <p class="text-white-50 mb-0">
            Your secure access has been restored. You can return to the DBE dashboard.
          </p>
        </div>
      </section>

      <section class="col-lg-6 p-4 p-md-5 d-flex align-items-center text-center">
        <div class="mx-auto w-100 py-lg-4" style="max-width: 28rem;">
          <router-link to="/login" class="d-flex d-lg-none justify-content-center mb-4" aria-label="Department of Basic Education login">
            <span class="auth-logo auth-logo-navbar d-block" aria-hidden="true"></span>
          </router-link>

          <span class="d-inline-flex align-items-center justify-content-center bg-success-subtle text-success rounded-circle p-3 mb-4">
            <i class="bi bi-check-lg fs-2" aria-hidden="true"></i>
          </span>

          <h2 class="h3 fw-bold mb-2">Password reset complete</h2>
          <p class="text-secondary mb-4">
            Your password has been reset successfully. Sign in using your new credentials.
          </p>

          <SnackbarMessage
            :success-message="success_message"
            @dismiss-success="success_message = ''"
          />

          <router-link to="/login" class="btn btn-primary w-100 py-2 d-inline-flex align-items-center justify-content-center gap-2">
            Return to sign in
            <i class="bi bi-arrow-right" aria-hidden="true"></i>
          </router-link>
        </div>
      </section>
    </div>
  </div>
</main>
